import { getActiveEntities } from '../utils/entities';
import { EditorState } from '../Editor.types';
import { AulaEntity } from '../Entities';

/**
 * Computes whether an EditorState has blocks that are currently
 * in the progress of fetching data
 * (can be used for greying out sent messages in conversations
 */
export const isUpdating = (editorState: EditorState) =>
  editorState.value.length > 0 &&
  Object.values(getActiveEntities(editorState)).some(
    (aulaEntity: AulaEntity) => aulaEntity.data == null && !aulaEntity.failed,
  );
